<script>
  import ImageProc from "./ImageProc.js";
  import Share from "./Share.svelte";

  let canViewResult = false;
  let resultDataUrl;

  const readFile = (files) => {
    if (!files || files.length === 0) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      const dataUrl = reader.result;
      document.getElementById("src").src = dataUrl;
      document.getElementById("src").onload = () => {
        generate();
      };
    };
  };

  const generate = () => {
    const frame = document.getElementById("frame");
    const frameCnv = document.getElementById("frameCnv");
    const frameCnvCtx = frameCnv.getContext("2d");
    frameCnv.width = frame.width;
    frameCnv.height = frame.height;
    frameCnvCtx.drawImage(frame, 0, 0);
    const src = document.getElementById("src");
    const srcCnv = document.getElementById("srcCnv");
    const srcCnvCtx = srcCnv.getContext("2d");
    srcCnv.width = src.width;
    if (srcCnv.width > 1200) {
      srcCnv.width = 1200;
    }
    srcCnvCtx.drawImage(src, 0, 0, srcCnv.width, srcCnv.height);
    const dstCnv = document.getElementById("dstCnv");
    const dstCnvCtx = dstCnv.getContext("2d");
    dstCnv.width = frame.width;
    dstCnv.height = frame.height;
    const srcCoordinates = [];
    srcCoordinates.push([0, 0]);
    srcCoordinates.push([srcCnv.width, 0]);
    srcCoordinates.push([srcCnv.width, srcCnv.height]);
    srcCoordinates.push([0, srcCnv.height]);
    const dstCoordinates = [];
    dstCoordinates.push([476, 109]);
    dstCoordinates.push([1074, 253]);
    dstCoordinates.push([1073, 571]);
    dstCoordinates.push([468, 609]);
    const param = ImageProc.getParam(srcCoordinates, dstCoordinates);

    const mx = ImageProc.getMX(param);
    const inv_param = ImageProc.getInvParam(mx);

    ImageProc.draw(srcCnv, dstCnv, dstCnv.width, dstCnv.height, inv_param);
    dstCnvCtx.drawImage(frame, 0, 0);
    resultDataUrl = dstCnv.toDataURL();
    canViewResult = true;
  };
</script>

<div class="parent">
  <div class="main">
    <h3>美術館シミュレーター</h3>
    <p class="description">好きな画像を美術館に飾れるぞ！</p>
    <span class="caution"
      >(画像はどこにもアップロードされません。あと指定する画像は横長の方が多分良いです。)</span
    >
    <img id="frame" class="hidden" src="/assets/image1.png" alt="img" />
    <img id="src" class="hidden" alt="img" />
    <canvas id="frameCnv" class="hidden" />
    <canvas id="srcCnv" class="hidden" />
    <div class={canViewResult ? "result" : "hidden"}>
      <canvas id="dstCnv" />
      <Share image={resultDataUrl} />
    </div>

    <input
      type="file"
      accept="image/*"
      on:change={(e) => {
        readFile(e.target.files);
      }}
    />
  </div>
  <hr />
  <div class="material">
    使用素材：
    <a
      href="https://unsplash.com/photos/a2MVpwmJ2Is"
      target="_blank"
      rel="noopener noreferrer"
    >
      group of men in black and white suits painting photo – Free National
      portrait gallery Image on Unsplash
    </a>
  </div>
  <hr />
  <footer class="copyright">
    © 2021
    <a
      href="https://twitter.com/de_teiu_tkg"
      target="_blank"
      rel="noopener noreferrer"
    >
      @de_teiu_tkg
    </a>
  </footer>
</div>

<style>
  .parent {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .result {
    margin: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  #dstCnv {
    width: 95%;
    max-width: 800px;
    position: relative;
    z-index: 100;
  }

  .description {
    margin-bottom: 0px;
  }
  .caution {
    font-size: 0.8em;
    margin-bottom: 10px;
  }
</style>
